/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class CommentService extends HttpHandlerService {

        constructor(private $http: ng.IHttpService) {
            super($http);
        }

        public createNewCommentThreadEntry(commentDto: Wars.Domain.Model.Dtos.CommentDto) : ng.IPromise<Wars.Domain.Model.Dtos.CommentThreadDto>
        {
            this.handlerUrl = "api/ManageProcess/ProcessComment";
            return this.usePostHandler(commentDto);
        }

        public createNewUserActionCommentReply(commentDto: Wars.Domain.Model.Dtos.CommentDto): ng.IPromise<Wars.Domain.Model.Dtos.CommentThreadDto>
        {
           this.handlerUrl = "api/ManageProcess/UserActionComment";
           return this.usePostHandler(commentDto);
        }

        public deleteComment(processId: string, commentId: string): ng.IPromise<any> {
            return this.$http.post('./api/Process/' + processId + '/DeleteComment/' + commentId,null);
        }
    }
}

warsApp.registerService('CommentService', ['$http']);